import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetCovered extends AbstractProductType {

  name = 'valet_covered'
  title = 'Valet Covered'

  valet = true
  format = ProductTypeFormat.Covered

}
